import React from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import {fetchBusinessById} from "../state/actions/business";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import HowItWorksScreenshots from "../parts/HowItWorksScreenshots";
import BusinessHeader from '../parts/BusinessHeader';
import BusinessTestimonial from '../parts/BusinessTestimonial';
import BusinessEndCallToAction from '../parts/BusinessEndCallToAction';
import Footer from '../parts/Footer';

import iPhoneYourShifts from '../assets/images/iphone-your-shifts.png';
import noUpfrontCosts from '../assets/images/icon-no-upfront-costs.png';
import reliable from '../assets/images/icon-reliable.png';
import iconOneLessThing from '../assets/images/icon-one-less-thing.png';
import iconManuallyScreened from '../assets/images/icon-manually-screened.png';
import heroBackgroundImage from '../assets/images/background-home-hero.jpg';


export class BusinessHomePage extends React.Component {
  componentDidMount() {
    window.analytics.page("Business", "Home");
  }

  getStartedClicked = () => {
    if (this.props.auth.token && this.props.business) {
      this.props.history.push('/' + this.props.business.slug);
    } else {
      this.props.history.push(config.routes.businessSignUp);
    }
  };

  render() {
    window.prerenderReady = true;
    const {classes} = this.props;

    return (
      <div className="business home">
        <Helmet>
          {title('SingleShift - Business')}
          {metaTitles('SingleShift - Business')}
          {metaDescriptions('Book online in minutes and schedule a Pro for whenever you need them in the next day or week.')}
          {metaImages(`${window.location.origin}${heroBackgroundImage}`)}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className={`hero`} style={{backgroundImage: `url(${heroBackgroundImage})`}}>
          <div className="container">
            <BusinessHeader/>
            <div className="row flex-md-row-reverse align-items-center">
              <div className="col-md-6 headline">
                <h1>Get the help you need in minutes.</h1>
                <p>Book online in seconds and schedule a Pro for whenever you need them.</p>
                <button onClick={this.getStartedClicked} type="button" className="btn btn-primary btn-xlg btn-pointer">Get Started </button>
              </div>
              <div className="col-md-6 text-center iphone">
                <img className="img-fluid" src={iPhoneYourShifts}/>
              </div>
            </div>
          </div>
        </div>

        {/* VALUE PROPS */}
        <div className="value_props">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-12">
                <h2 className="text-center">Why SingleShift?</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={noUpfrontCosts}/>
                  </div>
                  <div className="col-10 value">
                    <h4>No upfront costs</h4>
                    <p>Only pay when a shift successfully completed. No sneaky contracts or hidden fees.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconOneLessThing}/>
                  </div>
                  <div className="col-10 value">
                    <h4>One less thing to worry about</h4>
                    <p>SingleShift shows your post to hundreds of Pros, manages the back and forth and answers
                      questions, so you don't have to.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={iconManuallyScreened}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Manually screened for quality</h4>
                    <p>Pros on SingleShift are manually screened before they are allowed to work.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-2">
                    <img src={reliable}/>
                  </div>
                  <div className="col-10 value">
                    <h4>Committed to reliability</h4>
                    <p>SingleShift is designed to be reliable. Pros are screened, incentivized and reminded to appear
                      for their shifts.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* HOW IT WORKS */}
        <HowItWorksScreenshots/>

        <div className={classes.section}>
          <BusinessTestimonial/>
        </div>

        <BusinessEndCallToAction/>

        <Footer/>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  business: state.business.item,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  fetchBusinessById: (id) => dispatch(fetchBusinessById(id)),
});

const styles = (theme) => ({
  section: {
    padding: '100px 0',
    borderTop: '1px solid #efefef',
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BusinessHomePage));



// WEBPACK FOOTER //
// ./src/pages/BusinessHomePage.js